import React from 'react'
import { AddPackageLayer } from '../components/manage_packages/AddPackageLayer'
import MasterLayout from '../masterLayout/MasterLayout'

export const AddPackagePage = () => {
  return (
    <MasterLayout>

        <AddPackageLayer />
    </MasterLayout>
  )
}
